import { ActionPointInfo, Controller, IActionPointInfo, IDynamicLoader, Loader, Toolbar } from '@tencent/workbench';
import { config, TOOLBAR_ITEMS } from './config';
import React from 'react';
import TransitionDurationInput from '@com-pc/transition-duration-input';
import i18n from 'i18next';
import {
    TransitionDurationFeature,
} from '@framework/workbench/ui/transition/transition-duration/transition-duration-feature';
import { TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import { NumberInputFrom } from '@tencent/wb-ext-form';
import debounce from 'lodash/debounce';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class TransitionDurationController {
    private debounceUpdate = debounce(this.update, 500);
    public constructor(@Loader(TransitionDurationFeature) private loader: IDynamicLoader<TransitionDurationFeature>) {}

    @Toolbar(config.id, 'content')
    public getContent(@ActionPointInfo() info: IActionPointInfo) {
        const { transitionDuration } = this.feature;

        return <TransitionDurationInput
            icon={config.icon}
            text={i18n.t('持续时间')}
            value={transitionDuration / 1000}
            onValueChange={(val, from = NumberInputFrom.INPUT) => {
                const value = val * 1000;
                if (from === NumberInputFrom.INPUT) {
                    this.debounceUpdate(value);
                } else {
                    this.update(value);
                }
            }}
        />;
    }

    @Toolbar(config.id, 'shouldDisabled')
    public shouldDisable() {
        return this.feature.shouldDisabled(config.id);
    }

    private update(value: number) {
        this.feature.updateDuration(value);
    }

    private get feature() {
        return this.loader.instance!;
    }
}
